import type { FormDTO } from '../types/euforms';

export function isFormExpired(form: Pick<FormDTO, 'expirationDate'>): boolean {
  if (!form.expirationDate) return false;
  const endOfDay = new Date(`${form.expirationDate}T23:59:59`);
  return !Number.isNaN(endOfDay.getTime()) && Date.now() > endOfDay.getTime();
}

export function formatExpirationDate(value?: string | null): string {
  if (!value) return '';
  const [year, month, day] = value.split('-');
  return year && month && day ? `${day}/${month}/${year}` : value;
}
